export const METRES_IN_KILOMETRE = 1000;
export const METRES_IN_MILE = 1609.34;

// The backend always stores distance in metres and duration in seconds;
// unit conversion for display/entry happens here, driven by the user's
// live distance_unit setting (KILOMETRES or MILES).
export const metresToDistance = (metres, distanceUnit) => {
    if (metres === null || metres === undefined) return null;
    return distanceUnit === 'MILES' ? metres / METRES_IN_MILE : metres / METRES_IN_KILOMETRE;
};

export const distanceToMetres = (value, distanceUnit) => {
    if (value === null || value === undefined || value === '') return null;
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return null;
    return distanceUnit === 'MILES' ? numericValue * METRES_IN_MILE : numericValue * METRES_IN_KILOMETRE;
};

export const distanceUnitLabel = (distanceUnit) => distanceUnit === 'MILES' ? 'mi' : 'km';
